<table class="table table-sm">
  <thead>
    <tr>
      <th colspan="2">Movie</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Name</td>
      <td>{{ movie()?.Name }}</td>
    </tr>
    <tr>
      <td>Year</td>
      <td>{{ movie()?.Year }}</td>
    </tr>
    <tr>
      <td>Description</td>
      <td>{{ movie()?.Description }}</td>
    </tr>
    <tr>
      <td>Actors</td>
      <td>{{ movie()?.Actors }}</td>
    </tr>
    <tr>
      <td>Director</td>
      <td>{{ movie()?.Director }}</td>
    </tr>
  </tbody>
</table>